document.addEventListener('DOMContentLoaded', function () {
  const body = documnet.body;
  var header = document.querySelector('.site-header');
  const headerContainerBorder = document.getElementById('headerBorderWrap');
  var main = document.querySelector('.main-content');
  var logoImageHeight = document.querySelector('.logo-image.relative');
 
  if (header && main) {
    /*var height = header.offsetHeight;
    main.style.marginTop = height + "px";*/
  }
  
  window.addEventListener('scroll', function () {
    document.body.classList.toggle('is-stuck', window.scrollY > 180);    
    console.log('Scroll Y:', window.scrollY);
  });

  function updateLogoHeight() {
    if (body.classList.contains('is-stuck')) {
      if (logoImageHeight) {
        logoImageHeight.style.height = '60px';        
      }      
    }
  }
 
  updateLogoHeight();
 
  const observer = new MutationObserver(updateLogoHeight);
  observer.observe(body, {
    attributes: true,
    attributeFilter: ['class']
  });
  
});

